import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "../home/Home.css";
import { useNavigate } from "react-router-dom";
import GuideAuth from "../auth/GuideAuth";
import BotModal from "../common/BotModal";


import {
  FaFacebookF,
  FaInstagram,
  FaXTwitter,
  FaLinkedinIn,
} from "react-icons/fa6";
import { getUserData } from "../utils/storage";

const bots = [
  {
    icon: "/Images/phone-call.png",
    label: "Call",
    phone: "9821373111",
    type: "call",
  },
  {
    icon: "/Images/whatsapp.png",
    label: "Whatsapp",
    phone: "9821373111",
    message: "Hello, I want to know more about your services.",
    type: "whatsapp",
  },
  {
    icon: "/Images/gmail.png",
    label: "Mail",
    email: "support@safarixjourneys.com",
    subject: "Service Inquiry",
    body: "Hi, I'm interested in your services. Please provide more info.",
    type: "mail",
  },
];

function Footer() {
  const navigate = useNavigate();
   const guide = getUserData("guide");
   const user = getUserData("safarix_user");
    console.log("guide in header",guide)
  const [showChat, setShowChat] = useState(false);
  const [showGuideLogin, setShowGuideLogin] = useState(false);

  const toggleChat = () => {
    setShowChat(!showChat);
  };

  return (
    <>
      {/* ================= FOOTER ================= */}
      <footer className="footer">
        {/*BOT SECTION*/}
        <div className="floating-support">
          {bots
            .filter((bot) => bot.type === "whatsapp")
            .map((bot, index) => {
              const link = `https://wa.me/${bot.phone}?text=${encodeURIComponent(
                bot.message || "",
              )}`;

              return (
                <a
                  key={index}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="support-btn"
                >
                  <img src={bot.icon} alt={bot.label} />
                </a>
              );
            })}
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-6 col-md-3 mb-4">
              <h5>Know Us</h5>
              <ul className="list-unstyled">
                <li>
                  <a href="/" className="footer-style">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/about" className="footer-style">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="/blogs" className="footer-style">
                    Insights
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-sm-6 col-md-3 mb-4">
              <h5>Support</h5>
              <ul className="list-unstyled">
                <li>
                  <a href="/contact-us" className="footer-style">
                    Contact Us
                  </a>
                </li>
                <li>
                  <a href="/guide-careers" className="footer-style">
                    Join as Guide
                  </a>
                </li>
                {(!guide && !user) && (
                  <li
                    onClick={() => {
                      setShowGuideLogin(true);
                    }}
                  >
                    <a className="footer-style" style={{ cursor: "pointer" }}>
                      Login as Guide
                    </a>
                  </li>
                )}
               
              </ul>
            </div>

            <div className="col-sm-6 col-md-3 mb-4">
              <h5>Services</h5>
              <ul className="list-unstyled">
                <li>
                  <a href="/flights" className="footer-style">
                    Book Flight
                  </a>
                </li>
                <li>
                  <a href="/hotel" className="footer-style">
                    Book Hotel
                  </a>
                </li>
                <li>
                  <a href="/bus" className="footer-style">
                    Book Bus
                  </a>
                </li>
                <li>
                  <a href="/guides" className="footer-style">
                    Book Guide
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-sm-6 col-md-3 mb-4 text-center">
              <h5>Follow Us</h5>

              {/* Social Icons */}
              <div className="gap-2 mb-3 social-links">
                <a
                  href="https://www.facebook.com/profile.php?id=61584561766143"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://www.instagram.com/safarixjourneys"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://twitter.com/safarixjourneys"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaXTwitter />
                </a>
                <a
                  href="https://www.linkedin.com/company/safarix-journeys"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaLinkedinIn />
                </a>
              </div>
            </div>
          </div>

          {/* ================= FOOTER BOTTOM ================= */}

          <hr></hr>
          <div class="row footer-bottom">
            <div className="col-sm-4">
              <p>© 2026. All Rights Reserved | Safarix Journeys</p>
            </div>
            <div className="col-sm-4">
              <ul className="list-group list-group-horizontal">
                <li className="list-group-item">
                  <a href="/terms-conditions">Terms & Condition</a>
                </li>
                <li className="list-group-item">
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                <li className="list-group-item">
                  <a href="/cancelation">Cancellation Policy</a>
                </li>
              </ul>
            </div>
            <div className="col-sm-4"></div>
          </div>

          <button className="arix-chat" onClick={() => navigate("/bot-modal")}>
            <img
              src="/logo/Safarix Fav Icon.svg"
              alt="Arix Chatbot"
              style={{
                width: "65px",
                height: "65px",
                objectFit: "contain",
              }}
            />
            <span>Ask Arix</span>
          </button>
        </div>

        {showChat && <BotModal toggleChat={toggleChat} />}

        <GuideAuth
          show={showGuideLogin}
          onClose={() => setShowGuideLogin(false)}
          setShowGuideLogin={setShowGuideLogin}
        />
      </footer>
    </>
  );
}

export default Footer;
